import { ToolFailure, toolFailure } from './result'

// 框架層與情境層的錯誤碼（文件第 5 節）。錯誤碼一旦上線就不改名：它存進事件流。
// 🔒 葉子模組：只依賴 core/result，前端與略過提問的路由也會載入它。

// 框架層：執行閘門與確認機制產生，模型不自行重試、照實告訴使用者
const TOOL_ERROR = {
  TOOL_TIMEOUT: 'TOOL_TIMEOUT',
  TOOL_FAILED: 'TOOL_FAILED',
  TOOL_NOT_AUTHORIZED: 'TOOL_NOT_AUTHORIZED',
  TOOL_NOT_REGISTERED: 'TOOL_NOT_REGISTERED',
} as const

// 情境層：注入的範圍不足以執行，各工具只換「做不到什麼」那一段
const CONTEXT_ERROR = {
  VILLAGE_UNRESOLVED: 'VILLAGE_UNRESOLVED',
  ACTIVITY_NOT_ACCESSIBLE: 'ACTIVITY_NOT_ACCESSIBLE',
} as const

// 注入的 villageId 是空的（上游沒填進來）。consequence 例：「查不到活動」
const villageUnresolved = (consequence: string): ToolFailure => toolFailure(
  CONTEXT_ERROR.VILLAGE_UNRESOLVED,
  `目前無法確認登入身分的資料範圍，因此${consequence}。請重新登入後再試一次。`,
)

// 範圍外與不存在說同一句話。各工具的說法差異大，訊息整句由呼叫端給
const activityNotAccessible = (message: string): ToolFailure =>
  toolFailure(CONTEXT_ERROR.ACTIVITY_NOT_ACCESSIBLE, message)

export { CONTEXT_ERROR, TOOL_ERROR, activityNotAccessible, villageUnresolved }
